var map = {
	"./bg5.png": "z9bH",
	"./case1.png": "9FOh",
	"./case2.png": "nhx2",
	"./case3.png": "QEdt",
	"./picon1.png": "bciZ",
	"./picon2.png": "ZbHQ",
	"./picon3.png": "CKOY",
	"./picon4.png": "J3wG",
	"./productBg.08782bd.png": "dUKu",
	"./sicon1.png": "zlhd",
	"./sicon2.png": "d1EJ"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "JJg6";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sk ^\.\/.*$
// module id = JJg6
// module chunks = 16